import { Routes } from '@angular/router';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { RoutePath } from './shared/enums/common.enum';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { roleGuard } from './core/guards/role.guard';
import { subAdminOnlyGuard } from './core/guards/sub-admin-only.guard';

export const routes: Routes = [
    {
        path: '',
        canActivate: [guestGuard],
        loadComponent: () => import('./features/auth/pages/login-page/login-page.component').then(m => m.LoginPageComponent)
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        children: [

            {
                path: RoutePath.DASHBOARD,
                canActivate: [subAdminOnlyGuard, roleGuard],
                loadComponent: () => import('./features/auth/pages/dashboard/dashboard').then(m => m.DashboardComponent)
            },
            {
                path: RoutePath.SUB_ADMIN,
                canActivate: [roleGuard],
                data: { requiredRoles: ['sub-admin'] },
                loadChildren: () => import('./features/sub-admin/sub-admin.routes').then(m => m.SUB_ADMIN_ROUTES)
            },
            {
                path: RoutePath.FAQ,
                canActivate: [roleGuard],
                data: { requiredRoles: ['faq'] },
                loadChildren: () => import('./features/faq/faq.routes').then(m => m.FAQ_ROUTES)
            },
            {
                path: RoutePath.BLOG,
                canActivate: [roleGuard],
                data: { requiredRoles: ['blog'] },
                loadChildren: () => import('./features/blog/blog.routes').then(m => m.BLOG_ROUTES)
            },
            {
                path: RoutePath.CATEGORY,
                canActivate: [roleGuard],
                loadChildren: () => import('./features/category-management/category.routes').then(m => m.CATEGORY_ROUTES)
            },
            {
                path: RoutePath.PARTNERS,
                canActivate: [roleGuard],
                data: { requiredRoles: ['partners'] },
                loadChildren: () => import('./features/partners/partners.routes').then(m => m.PARTNER_ROUTES)
            },
            {
                path: 'banners',
                canActivate: [roleGuard],
                data: { requiredRoles: ['banners'] },
                loadChildren: () => import('./features/banner/banner.routes').then(m => m.BANNER_ROUTES)
            },
            {
                path: RoutePath.AUDIT_REPORT,
                canActivate: [roleGuard],
                data: { requiredRoles: ['audit-report'] },
                loadChildren: () => import('./features/audit-report/audit-report.routes').then(m => m.AUDIT_REPORT_ROUTES)
            },
            {
                path: RoutePath.ANNOUNCEMENT,
                canActivate: [roleGuard],
                data: { requiredRoles: ['announcements'] },
                loadChildren: () => import('./features/announcement/announcement.routes').then(m => m.ANNOUNCEMENT_ROUTES)
            },
            {
                path: RoutePath.VOTE_DOMAIN,
                canActivate: [roleGuard],
                data: { requiredRoles: ['vote-domain'] },
                loadChildren: () => import('./features/vote-domain/vote-domain.routes').then(m => m.VOTE_DOMAIN_ROUTES)
            },
            {
                path: RoutePath.DOCS,
                canActivate: [roleGuard],
                data: { requiredRoles: ['docs'] },
                loadChildren: () => import('./features/docs/docs.routes').then(m => m.DOCS_ROUTES)
            },
            {
                path: RoutePath.ROLE_DELEGATION_TRACKER,
                canActivate: [roleGuard],
                data: { requiredRoles: ['role-delegation-tracker'] },
                loadComponent: () => import('./features/role-delegation-tracker/role-delegation-tracker.component').then(m => m.RoleDelegationTrackerComponent)
            },
            {
                path: RoutePath.DELEGATION_HISTORY,
                canActivate: [roleGuard],
                data: { requiredRoles: ['delegation-history'] },
                loadComponent: () => import('./features/delegation-history/delegation-history.component').then(m => m.DelegationHistoryComponent)
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
